import { GallectionSortOrder } from '../../../../types/gallection';
import { SectionViewType } from '../../../../types/sections';

export const DEFAULT_GALLECTION_SORT_ORDER = GallectionSortOrder.NEWEST;
export const DEFAULT_GALLECTION_VIEW_TYPE = SectionViewType.LIST;
